






























import { mapGetters } from 'vuex'
import { ScaleAffectorMode, ScaleAffectorConfig, FloatPropertyMode } from '../../pfx/emitterConfig'
import PropEditorFloat from "./proped-float.vue";
import { safeParseFloat, formatNumber, findAffector, removeAffector } from '../../utils'

export default {
	name: 'PropEditorAffectorScale',
    components: {
		PropEditorFloat,
    },
    props: {
        onchange: Function, 
        emitter: Object
    },
    enums: {
       ScaleAffectorMode 
    },
    data: function () {
        return {
        }
    },
    methods: {
        triggerChange: function() {
            this.onchange();
        },
        createAffector: function(initialMode) {
            return {
                mode: initialMode,
                constSpeed: {
                    mode: FloatPropertyMode.Constant,
                    val: 0,
                    min: 0,
                    max: 0
                },
                target: {
                    mode: FloatPropertyMode.Constant,
                    val: 0,
                    min: 0,
                    max: 0
                },
                times: [
                    {
                        mode: FloatPropertyMode.Constant,
                        val: 0.5,
                        min: 0,
                        max: 0
                    },
                    {
                        mode: FloatPropertyMode.Constant,
                        val: 0.5,
                        min: 0,
                        max: 0
                    }
                ]
            }
        }
    },
	computed: {
        mode: {
            get() {
                let aff:ScaleAffectorConfig = findAffector(this.emitter, "scale");
                if(!aff)
                    return ScaleAffectorMode.Disabled;
                return aff.mode;
            },
            set(newVal:number) {
                let aff:ScaleAffectorConfig = findAffector(this.emitter, "scale");
                if(!aff) {
                    aff = this.createAffector(newVal);
                    this.emitter.affectors.push({
                        id: "scale",
                        cfg: aff
                    });
                } else {
                    if(newVal == ScaleAffectorMode.Disabled) {
                        removeAffector(this.emitter, "scale")
                    } else {
                        aff.mode = newVal;
                    }
                }

                this.triggerChange();
            }
        },
        constSpeed: {
            get() {
                let aff:ScaleAffectorConfig = findAffector(this.emitter, "scale");
                return aff.constSpeed;
            },
        },
        target: {
            get() {
                let aff:ScaleAffectorConfig = findAffector(this.emitter, "scale");
                return aff.target;
            }
        },
        times0: {
            get() {
                let aff:ScaleAffectorConfig = findAffector(this.emitter, "scale");
                return aff.times[0];
            }
        },
        times1: {
            get() {
                let aff:ScaleAffectorConfig = findAffector(this.emitter, "scale");
                return aff.times[1];
            }
        }
	}
}
